const errorPage = () => import('@/pages/errorPage/notFound.vue');
const login = () => import('@/pages/login/index.vue');

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      requireAuth: false,
      hideTopbar: true,
      title: '登录'
    }
  },
  {
    path: '/404',
    name: '404',
    component: errorPage,
    meta: {
      requireAuth: false,
      title: '404'
    }
  }
];

export default routes;
